import report from './../../../services/purchase/supplierAccountStatement'
import supplierAPI from './../../../services/purchase/supplier';
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        supplier_id: null,
        account_id: null,
        from: moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
        loading: false,
        data: {
            account: {
                currency: {}
            },
            statement: {
                running: [],
                opening: {},
                account: {},
                closing: {}
            }
        },
        suppliers: [],
        suppliersLoading: false,
        accounts: []
    },
    mutations: {
        params: (state, payload) => state.params = payload,
        data: (state, payload) => state.data = payload,
        loading: (state, payload) => state.loading = payload,
        suppliers: (state, payload) => state.suppliers = Array.from(new Set([...state.suppliers, ...payload])),
        suppliersLoading: (state, payload) => state.suppliersLoading = payload,
        supplierID: (state, payload) => {
            state.supplier_id = payload
            let supplier = state.suppliers.find(each => each.id == payload);
            // if supplier not found
            if(!supplier) { 
                state.accounts = []
                return;
            }
            // if accounts is not array (null, undefined, object)
            if(!Array.isArray(supplier.accounts)) {
                state.accounts = []
                return;
            }
            state.accounts = supplier.accounts
        },
        accountID: (state, payload) => state.account_id = payload,
        from: (state, payload) => state.from = payload,
        to: (state, payload) => state.to = payload
    },
    actions: {
        reset({commit}) {
            commit("data", {
                account: {
                    currency: {}
                },
                statement: {
                    running: [],
                    opening: {},
                    account: {},
                    closing: {}
                }
            })
        },
        fetch({state, commit, dispatch}) {
            dispatch("reset")
            commit("loading", true);
            report.statement({
                supplier_id: state.supplier_id,
                account_id: state.account_id,
                from: state.from,
                to: state.to
            })
            .then(response =>  commit("data", response.data))
            .finally(() => commit("loading", false))
        },
        searchSuppliers({commit}, payload) {
            commit("suppliersLoading", true);
            supplierAPI.search(payload).then(response => {
                commit("suppliers", response.data)
            }).finally(() => {
                commit("suppliersLoading", false)
            })
        },
        fetchSupplier(context, payload) {
            return new Promise((resolve) => {
                supplierAPI.find(payload).then(response => {
                    resolve(response.data)
                })
            })
        },
        async inputSupplierID({commit, dispatch}, payload) {
            let supplier = await dispatch("fetchSupplier", payload)
            commit("suppliers", [supplier]);
            commit("supplierID", payload)
        },
        inputAccountID({commit}, payload) {
            commit("accountID", payload)
        },
        inputFrom({commit}, payload) {
            commit("from", payload)
        },
        inputTo({commit}, payload) {
            commit("to", payload)
        },
        async init({dispatch}, {supplier_id, account_id, from, to}) {
            await dispatch("inputSupplierID", supplier_id);
            dispatch("inputAccountID", account_id);
            dispatch("inputFrom", from);
            dispatch("inputTo", to);
            dispatch("fetch")
        }
    }
}